<template>
    <div>
        <v-row>
            <v-col>
                <div>Login</div>
                <v-form @submit.prevent="submit">
                    <div class="mt-4">
                        <text-field
                            label="Email"
                            type="email"
                            v-model="form.email"
                            required
                            autofocus
                            autocomplete="username"
                        />
                    </div>

                    <div class="mt-4">
                        <text-field
                            label="Password"
                            type="password"
                            v-model="form.password"
                            required
                            autocomplete="current-password"
                        />
                    </div>

                    <div class="mt-4">
                        <v-checkbox
                            v-model="form.remember"
                            label="Remember me"
                        />
                    </div>

                    <div
                        class="d-flex align-center justify-end mt-4"
                        style="width: 100%"
                    >
                        <div>
                            <inertia-link
                                v-if="canResetPassword"
                                :href="route('password.request')"
                            >
                                Forgot your password?
                            </inertia-link>
                        </div>

                        <v-btn
                            type="submit"
                            class="ml-4"
                            :loading="form.processing"
                            :disabled="form.processing"
                        >
                            Log in
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BreezeGuestLayout from "@/Layouts/GuestLayout";
import TextField from "../../Components/Forms/TextField";

export default {
    layout: BreezeGuestLayout,

    components: {
        TextField
    },

    props: {
        auth: Object,
        canResetPassword: Boolean,
        errors: Object,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                remember: false,
            }),
        };
    },

    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login"), {
                    onFinish: () => this.form.reset("password"),
                });
        },
    },
};
</script>
